<template>
  <div class="page">
    <StudentPage />
  </div>
</template>

<script>
import StudentPage from "@/components/objSelectPage/student.vue";
export default {
  name: "StudentSelect",
  components: {
    StudentPage,
  },
};
</script>

<style lang="less" scoped>
</style>
